import { render, staticRenderFns } from "./BdCommodity.vue?vue&type=template&id=5bead7db&scoped=true&"
import script from "./BdCommodity.vue?vue&type=script&lang=js&"
export * from "./BdCommodity.vue?vue&type=script&lang=js&"
import style0 from "./BdCommodity.vue?vue&type=style&index=0&id=5bead7db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bead7db",
  null
  
)

export default component.exports